const types = {
    ascii: {
        id: 'ascii',
        organization: 'SST',
        description: 'Basic ASCII encoding'
    },
    hex: {
        id: 'hex',
        organization: 'SST',
        description: 'Default HEX encoding'
    },
    //sg1 EPC Global
    // (Consumable) Inventory
    sgtin96: {
        id: 'sgtin-96',
        prefix: '30',
        organization: 'GS1',
        description: 'Serialized Global Trade Item Number'
    },
    // (Consumable) Inventory
    sgtin198: {
        id: 'sgtin-198',
        prefix: '36',
        organization: 'GS1',
        description: 'Serialized Global Trade Item Number'
    },
    gid96: {
        id: 'gid-96',
        prefix: '35',
        organization: 'GS1',
        description: 'General Identifier'
    },
    giai96: {
        id: 'giai-96',
        prefix: '34',
        organization: 'GS1',
        description: 'Global Individual Asset Identifier'
    },
    giai202: {
        id: 'giai-202',
        prefix: '38',
        organization: 'GS1',
        description: 'Global Individual Asset Identifier'
    },
    grai96: {
        id: 'grai-96',
        prefix: '33',
        organization: 'GS1',
        description: 'Global Returnable Asset Identifier'
    },
    grai170: {
        id: 'grai-170',
        prefix: '37',
        organization: 'GS1',
        description: 'Global Returnable Asset Identifier'
    },
    sscc96: {
        id: 'sscc-96',
        prefix: '31',
        organization: 'GS1',
        description: 'Serial Shipping Container Code'
    },
    sgln96: {
        id: 'sgln-96',
        prefix: '32',
        organization: 'GS1',
        description: 'Global Location Number With or Without Extension'
    },
    sgln195: {
        id: 'sgln-195',
        prefix: '39',
        organization: 'GS1',
        description: 'Global Location Number With or Without Extension'
    },

    /** Not supported in our library yet, but supported in epc-tds lib */
    gsrn96: {
        id: 'gsrn-96',
        prefix: '2D',
        organization: 'GS1',
        description: 'Global Service Relation Number'
    },
    gdti96: {
        id: 'gdti-96',
        prefix: '2C',
        organization: 'GS1',
        description: 'Global Document Type Identifier'
    },
    gdti174: {
        id: 'gdti-174',
        prefix: '3E',
        organization: 'GS1',
        description: 'Global Document Type Identifier'
    },
    cpi96: {
        id: 'cpi-96',
        prefix: '3C',
        organization: 'GS1',
        description: 'Component / Part Identifier'
    },
    sgcn96: {
        id: 'sgcn-96',
        prefix: '3F',
        organization: 'GS1',
        description: 'Serialized Global Coupon Number'
    },
    //TE TrueView
    vueSerAuth: {
        id: 'serauth',
        prefix: '3BE',
        organization: 'Tyco',
        description: 'TrueView serial Authority (Propriatary SGTIN Alternative)'
    },
    vueLic: {
        id: 'lic',
        prefix: '3BF',
        organization: 'Tyco',
        description: 'TrueView License Plate (Serialized "Display Tags")'
    },
    //iata
    baggage: {
        id: 'baggage',
        prefix: '0C',
        organization: 'IATA',
        description: 'IATA RP1740c Baggage Handling identifier'
    }
};
Object.freeze(types);
module.exports = types;
